import { useEffect } from 'react'
import { Switch, Route } from 'wouter'
import { useOfferStore } from '@store/offerStore'
import { Header } from './components/Header'
import { FilterBar } from './components/FilterBar'
import { StatsBar } from './components/StatsBar'
import { OfferGrid } from './components/OfferGrid'
import { ComparisonView } from './components/ComparisonView'
import { HealthDashboard } from './components/HealthDashboard'
import { AdminShell } from './admin/AdminShell'
import styles from './App.module.css'

export function App() {
  return (
    <Switch>
      <Route path="/admin" nest component={AdminShell} />
      <Route component={ConsumerShell} />
    </Switch>
  )
}

function ConsumerShell() {
  const fetchOffers = useOfferStore(s => s.fetchOffers)

  useEffect(() => { fetchOffers() }, [fetchOffers])

  return (
    <div className={styles.app}>
      <Header />
      <main className={styles.content}>
        <FilterBar layoutClassName={styles.filterBarLayout} />
        <StatsBar layoutClassName={styles.statsBarLayout} />
        <ConsumerView />
      </main>
      <Footer />
    </div>
  )
}

function ConsumerView() {
  return (
    <Switch>
      <Route path="/health">
        <HealthDashboard layoutClassName={styles.healthDashboardLayout} />
      </Route>
      <Route path="/compare">
        <ComparisonView layoutClassName={styles.comparisonViewLayout} />
      </Route>
      <Route>
        <OfferGrid />
      </Route>
    </Switch>
  )
}

function Footer() {
  return (
    <footer className={styles.componentFooter}>
      <p>
        Bio Aanbiedingen NL — Biologische groente & fruit aanbiedingen van Nederlandse supermarkten.
      </p>
      <p style={{ marginTop: '4px' }}>
        Prijzen en beschikbaarheid kunnen afwijken. Kijk altijd op de website van de supermarkt voor de actuele prijs.
      </p>
    </footer>
  )
}
